import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.AuditLog.ClaimAuditLogs.IRequest;
type Response = Api.Core.AuditLog.ClaimAuditLogs.IResponse;
type Headers = Api.Core.AuditLog.ClaimAuditLogs.IHeaders;
const url = '/api/Management/AuditLog/GetClaimLogs/:claimId';
export default async function auditLogGetClaimAuditLogsApi(params?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, { claimId: params.claimId }),
    headers: getDefaultHeaders(),
  });
}
